export enum FEATURE {
  PRO_CUSTOMER = 'PRO_CUSTOMER',
}
